import { Component } from "@angular/core";
import { FormField } from "src/app/interfaces/form-field.model";
import {
  faFloppyDisk,
  faEraser,
} from "@fortawesome/free-solid-svg-icons";
import { ParfTransferDateService } from "src/app/services/autopac/parf-transfer-date.service";
import { NotifierService } from "angular-notifier";

@Component({
  selector: "app-parf-transfer-date",
  templateUrl: "./parf-transfer-date.component.html",
})
export class ParfTransferDateComponent {
  faFloppyDisk = faFloppyDisk;
  faEraser = faEraser;

  parfForm: FormField[] = [
    {
      label: "Contract Number",
      id: "ContractNo",
      type: "search",
      searchEvent: true,
      isAuto: true,
    },
    {
      label: "PARF Transfer Date (dd/mm/yyyy)",
      id: "ParfTransferDate",
      type: "date",
    },
  ];

  referenceForm: FormField[] = [
    {
      label: "Contract Date",
      id: "ContractDate",
      type: "date",
      lock: true,
    },
    {
      label: "PARF Value",
      id: "ParfValue",
      type: "number",
      lock: true,
    },
    {
      label: "COE Rebate Value",
      id: "CoeValue",
      type: "number",
      lock: true,
    },
    {
      label: "Total PARF Amount",
      id: "Total",
      type: "number",
      value: 0,
      lock: true,
    },
  ];

  constructor(
    private parfService: ParfTransferDateService,
    private notifier: NotifierService,
  ) {}

  handleSearch(): void {
    const ContractNo = this.getField("ContractNo").value;

    if (!ContractNo) {
      this.notifier.notify(
        "error",
        "Please input valid contract Number",
      );
      return;
    }

    this.parfService.getParfDetails(ContractNo).subscribe({
      next: (response) => {
        const formatDate = (dateStr: string): string => {
          if (!dateStr) return "";
          const [dd, mm, yyyy] = dateStr.split("/");
          return `${yyyy}-${mm}-${dd}`;
        };

        const dateFields = ["ParfTransferDate", "ContractDate"];

        for (const [key, value] of Object.entries(response.body)) {
          this.getField(key).value = dateFields.includes(key)
            ? formatDate(value as string)
            : value;
        }
      },
      error: (error) => {
        console.error("Error retrieving PARF details:", error);
      },
    });
  }

  update(): void {
    const ContractNo = this.getField("ContractNo").value;
    const ParfTransferDate = this.getField("ParfTransferDate").value;

    if (!ContractNo || !ParfTransferDate) {
      this.notifier.notify(
        "error",
        "Please provide both Contract Number and PARF Transfer Date.",
      );
      return;
    }

    const [yyyy, mm, dd] = ParfTransferDate.split("-");
    const FormattedDate = `${dd}/${mm}/${yyyy}`;

    this.parfService
      .updateParfDate(ContractNo, FormattedDate)
      .subscribe({
        next: (response) => {
          this.notifier.notify(
            response.code === 0 ? "success" : "error",
            response.message,
          );
        },
        error: (err) => {
          console.error("Error updating PARF date:", err);
        },
      });
  }

  clear() {
    const forms = [...this.parfForm, ...this.referenceForm];
    forms.forEach((item: FormField) => {
      if (item.id !== "Total") {
        this.getField(item.id).value = undefined;
      }
    });
  }

  getField(id: string): FormField {
    const forms: FormField[] = [
      ...this.parfForm,
      ...this.referenceForm,
    ];
    return (
      forms.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }
}
